import React from 'react';
import {TagPills} from '../JobsView.styles';
import {JobFilters} from '../jobs.callbacks';
import {TagPill} from 'epic-ue-ui';
import {stopFocusOnClick} from 'epic-ue-shared';

interface Props {
    jobsFilters: JobFilters;
    removeFilter: (e: any, filterName: string, value: string) => void;
}

export const CurrentFilterTags = ({jobsFilters, removeFilter}: Props): JSX.Element => {
    return (
        <TagPills>
            {Object.keys(jobsFilters).map((jobFilterType, keyIndex) => {
                if (jobFilterType === 'page') return;
                return jobsFilters[jobFilterType].map((jobsFilter) => {
                    return (
                        <div
                            role="button"
                            tabIndex={keyIndex}
                            onClick={(e) => removeFilter(e, jobFilterType, jobsFilter)}
                            onMouseDown={stopFocusOnClick}
                            key={jobsFilter}>
                            {jobFilterType === 'remote' && jobsFilter === 'true' ? (
                                <TagPill label={'Remote'} />
                            ) : (
                                <TagPill label={jobsFilter} />
                            )}
                        </div>
                    );
                });
            })}
        </TagPills>
    );
};
